module.exports = __webpack_public_path__ + "img/Nora-logo_big.02c35a.png";